import { Component, OnDestroy, OnInit } from '@angular/core';
import { IBaryModalEvent } from '../../../../../models/bary-modal-event';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ISpecialPlace } from '../../../../../models/special-place.model';
import { HttpResponse } from '@angular/common/http';
import { BaryComponentHelper } from '../../../util/bary-component-helper';
import { BaryModalForm } from '../../../../../models/bary-modal-form';
import { Observable, Subscription } from 'rxjs';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { EventManager } from '../../../../../services/event-manager.service';
import { patchObject } from '../../../util/object-util';

@Component({
  templateUrl: './special-place-create-dialog.component.html',
})
export class SpecialPlaceCreateDialogComponent extends BaryModalForm implements OnInit, OnDestroy {
  override action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  declare model: ISpecialPlace;
  isSaving = false;

  controls!: {
    id: FormControl;
    country: FormControl;
    inseeCode: FormControl;
    zipCode: FormControl;
    city: FormControl;
  };
  declare modalForm: FormGroup;
  eventSubscriber?: Subscription;

  constructor(public modalRef: MDBModalRef, protected eventManager: EventManager, private fb: FormBuilder) {
    super();
  }

  override ngOnDestroy(): void {
    if (this.eventSubscriber) {
      this.eventManager.destroy(this.eventSubscriber);
      this.eventManager.destroy(this.eventSubscriber);
    }
  }

  previousState(): void {
    window.history.back();
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<ISpecialPlace>>): Subscription {
    return result.subscribe(
      () => this.onSaveSuccess(),
      () => this.onSaveError()
    );
  }

  protected onSaveSuccess(): void {
    this.isSaving = false;
    this.eventManager.broadcast('specialPlaceListModification');
    this.modalRef.hide();
  }

  protected onSaveError(): void {
    this.isSaving = false;
  }

  ngOnInit(): void {
    this.controls = {
      id: this.fb.control(this.model.id, []),
      country: this.fb.control(this.model.country, [Validators.required]),
      inseeCode: this.fb.control(this.model.inseeCode, [Validators.required]),
      zipCode: this.fb.control(this.model.zipCode, [Validators.required]),
      city: this.fb.control(this.model.city, [Validators.required]),
    };

    this.modalForm = this.fb.group(this.controls);
  }

  handleClick(event: IBaryModalEvent): void {
    this.action.next(event);
    this.modalRef.hide();
  }

  override handleSubmit(form: any): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      patchObject(this.model, this.modalForm.value);
      form.value = this.model;
      this.action.next(form);
      this.modalRef.hide();
    }
  }
}
